import * as moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { ApplicationState } from 'src/store';
import { getEventsPerDay } from 'src/store/events/actions';
import EventsDailyItem from '../EventsDaily/EventsDailyItem/EventsDailyItem';

import './EventsPerDay.scss';

interface Props {
  eventsById: any;
  allEvents: any;
  pending: boolean;
  getEventsPerDay: typeof getEventsPerDay;
  sectionTitle: string;
}

interface State {
  selectedDay: moment.Moment;
  forward: boolean;
  backwards: boolean;
}

class EventsPerDay extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedDay: moment(),
      forward: true,
      backwards: true
    };
  }

  componentDidMount() {
    this.getWeeks();
  }

  getWeeks = () => {
    this.props.getEventsPerDay(this.state.selectedDay, this.props.sectionTitle);
  };

  onNext = () => {
    this.setState({ selectedDay: moment(this.state.selectedDay).add(1, 'd') }, () =>
      this.getWeeks()
    );
  };

  onPrevious = () => {
    this.setState({ selectedDay: moment(this.state.selectedDay).subtract(1, 'd') }, () =>
      this.getWeeks()
    );
  };

  public render() {
    const { pending } = this.props;
    const { forward, backwards } = this.state;
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 style={{ textTransform: 'uppercase', fontSize: '1.3rem', textAlign: 'left' }}>
              Veranstaltungen
            </h2>
            <div className="controls">
              <span
                className={backwards ? '' : 'disabled'}
                onClick={() => {
                  if (backwards) {
                    this.onPrevious();
                  }
                }}
              >
                &lt;
              </span>
              <span style={{ fontSize: '1.3rem' }}>
                {moment(this.state.selectedDay).format('dddd DD.MM.')}
              </span>
              <span
                className={forward ? '' : 'disabled'}
                onClick={() => {
                  if (forward) {
                    this.onNext();
                  }
                }}
              >
                &gt;
              </span>
            </div>
          </div>
          <div className="col-12">
            <LoadingSpinner pending={pending} />

            <ul style={{ width: '100%', position: 'relative' }}>
              {this.props.allEvents.map((i: number, counter: number) => {
                const event = this.props.eventsById[i];
                return <EventsDailyItem event={event} key={counter} />;
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ events }: ApplicationState) => ({
  eventsById: events.data.byId,
  allEvents: events.data.nextDay,
  pending: events.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  getEventsPerDay: (day: moment.Moment, sectionTitle: string) =>
    dispatch(getEventsPerDay(day, sectionTitle))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsPerDay);



// WEBPACK FOOTER //
// ./src/components/Event/EventPerDay/EventsPerDay.tsx